/* ==========================================================================
   Loja do Gamão — WhatsApp
   1. Botão flutuante: recolhe o texto e desvia da barra "Adicionar à sacola".
   2. Bloco do produto: atualiza a mensagem quando o cliente troca a variante.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'lgWaLabelSeen';

  function storageGet() {
    try { return window.sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function storageSet() {
    try { window.sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* noop */ }
  }

  /* ------------------------------------------------------------------------
     1. Botão flutuante
     ------------------------------------------------------------------------ */
  function initFloat() {
    var el = document.querySelector('[data-wa-float]');
    if (!el || el.dataset.bound === '1') return;
    el.dataset.bound = '1';

    var seconds = parseFloat(el.getAttribute('data-collapse') || '0');
    var collapsedByRule = false;

    // Texto aberto na chegada; recolhe depois de X segundos ou ao rolar.
    // Recolhido uma vez, só volta aberto na próxima visita (sessão).
    if (seconds > 0) {
      if (storageGet() === '1') {
        el.classList.add('is-collapsed');
        collapsedByRule = true;
      } else {
        var timer = null;

        var collapse = function () {
          if (collapsedByRule) return;
          collapsedByRule = true;
          el.classList.add('is-collapsed');
          storageSet();
          window.clearTimeout(timer);
          window.removeEventListener('scroll', onScroll);
        };

        var onScroll = function () {
          if (window.scrollY > 600) collapse();
        };

        timer = window.setTimeout(collapse, seconds * 1000);
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      // No computador, passar o mouse mostra o texto de novo.
      el.addEventListener('mouseenter', function () {
        el.classList.remove('is-collapsed');
      });
      el.addEventListener('mouseleave', function () {
        if (collapsedByRule) el.classList.add('is-collapsed');
      });
    }

    // Página de produto no celular: a barra "Adicionar à sacola" é sticky.
    // Enquanto ela estiver presa no rodapé da tela, o botão sobe por cima dela.
    var bar = document.querySelector('.product__sticky');
    if (!bar) return;

    var ticking = false;

    function measure() {
      ticking = false;
      var offset = 0;

      if (window.getComputedStyle(bar).display !== 'none') {
        var rect = bar.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;

        if (rect.height > 0 && rect.top < vh && rect.bottom >= vh - 2) {
          offset = Math.max(0, Math.round(vh - rect.top));
        }
      }

      el.style.setProperty('--lg-wa-offset', offset + 'px');
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    measure();
  }

  /* ------------------------------------------------------------------------
     2. Bloco do produto
     ------------------------------------------------------------------------ */
  function buildMessage(template, title, variant) {
    var msg = template.split('[produto]').join(title);

    if (variant.sku) {
      msg = msg.split('[codigo]').join(variant.sku);
    } else {
      msg = msg.split(' ([codigo])').join('').split('([codigo])').join('').split('[codigo]').join('');
    }

    return msg.split('[link]').join(variant.url).trim();
  }

  function initCards(scope) {
    (scope || document).querySelectorAll('[data-wa-card]').forEach(function (card) {
      if (card.dataset.bound === '1') return;
      card.dataset.bound = '1';

      var wrapper = card.parentNode;
      var dataEl = wrapper ? wrapper.querySelector('[data-wa-variants]') : null;
      var section = card.closest('[data-product-root]');
      if (!dataEl || !section) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var base = (card.getAttribute('href') || '').split('?')[0];
      var template = card.getAttribute('data-wa-template') || '';
      var title = card.getAttribute('data-wa-product') || '';
      var idInput = section.querySelector('form [name="id"]');
      if (!base || !template || !idInput) return;

      function update() {
        var variant = variants[idInput.value];
        if (!variant) return;
        card.setAttribute('href', base + '?text=' + encodeURIComponent(buildMessage(template, title, variant)));
      }

      // O seletor de variantes troca o input "id" depois do evento change.
      section.addEventListener('change', function () {
        window.setTimeout(update, 0);
      });
    });
  }

  function init(scope) {
    initFloat();
    initCards(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Editor de temas da Shopify: reativa quando uma seção é recarregada.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
